import { Text, TextProps } from "@chakra-ui/react";

export type Font = [
  fontFamily: "Inter" | "Cairo" | "Open Sans",
  fontWeight: string | number,
  fontSize: string | number,
  lineHeight: string | number
];

type BaseTextProps = TextProps & {
  font?: Font;
};
const BaseText: React.FC<BaseTextProps> = ({ font, children, ...props }) => {
  const [
    fontFamily = "Open Sans",
    fontWeight = "400",
    fontSize = "16px",
    lineHeight = 1,
  ] = font || [];
  return (
    <Text
      {...props}
      fontFamily={fontFamily}
      fontWeight={fontWeight}
      fontSize={fontSize}
      lineHeight={lineHeight}
    >
      {children}
    </Text>
  );
};

export { BaseText };
